module.exports = __webpack_public_path__ + "static/media/chat.7909c309.svg";